import type { IDropDownItem } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";
import {
    StyledDropdownParent,
    StyledSingleSelectDDItem,
    StyledSingleSelectDDItemText,
} from "app/pages/sales-intelligence/common-components/dropdown/styles";
import { buildDropdownSelectedItemsFromArray } from "app/pages/sales-intelligence/utils/dropdowns";
import useDelayedAction from "app/pages/sales-intelligence/hooks/useDelayedAction";
import useUncontrolledDropdown from "app/pages/sales-intelligence/hooks/useUncontrolledDropdown";
import { DROPDOWN_AUTO_OPEN_DELAY } from "app/pages/sales-intelligence/sub-modules/signals/constants/dropdown";
import type { FC } from "react";
import FilterButtonLabel from "../shared/FilterDropdown/FilterButtonLabel/FilterButtonLabel";
import SignalFilterDropdownButton
    from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/SignalFilterDropdownButton/SignalFilterDropdownButton";

type FilterValue = number;

type DropdownItem = Omit<IDropDownItem, "id"> & {
    id: FilterValue;
};

type Props = {
    selectedValue: FilterValue | undefined;
    options: readonly FilterValue[];
    autoOpen?: boolean;
    onValueChange(value: FilterValue): void;
};

const SignalTrafficChangesValueFilter: FC<Props> = ({ selectedValue, options, autoOpen = false, onValueChange }) => {
    const selectedItems: Record<FilterValue, boolean> = buildDropdownSelectedItemsFromArray(
        selectedValue ? [selectedValue] : [],
    );

    const { dropdownRef, onUncontrolledOpen } = useUncontrolledDropdown();

    useDelayedAction(DROPDOWN_AUTO_OPEN_DELAY, onUncontrolledOpen, autoOpen);

    const getDisplayValue = (value: FilterValue | undefined = 0): string => {
        return `${value * 100}%`;
    };

    const handleChangeValue = (item: DropdownItem): void => {
        onValueChange(item.id);
    };

    return (
        <StyledDropdownParent id="traction-changes-value-dd">
            <Dropdown
                ref={dropdownRef}
                appendTo="#traction-changes-value-dd"
                selectedIds={selectedItems}
                width={150}
                dropdownPopupHeight={190}
                onClick={handleChangeValue}
            >
                <SignalFilterDropdownButton
                    id="changing-traction-value-dd-button"
                    key="button"
                >
                    <FilterButtonLabel>{getDisplayValue(selectedValue)}</FilterButtonLabel>
                </SignalFilterDropdownButton>

                {...options.map((option: number) => (
                    <StyledSingleSelectDDItem
                        key={option}
                        id={option}
                    >
                        <StyledSingleSelectDDItemText>{getDisplayValue(option)}</StyledSingleSelectDDItemText>
                    </StyledSingleSelectDDItem>
                ))}
            </Dropdown>
        </StyledDropdownParent>
    );
};

export default SignalTrafficChangesValueFilter;
